import { IUploadFileToEntityActionPayload } from 'app/projects/entity/src/lib/interfaces/upload-file-to-entity.action-payload.interface';

export class UpdateUserProfilePicture {
    static readonly type = '[User] UpdateUserProfilePicture';

    constructor(public payload: IUploadFileToEntityActionPayload) {}
}
